<template>
  <tela-component title="Configuração da conta">
    <carregando-padrao v-if="loading" />
    <template v-else>
      <v-row dense>
        <v-col cols="12">
          <alterar-senha v-if="meusDados.podealterarsenha" />
        </v-col>
      </v-row>
      <v-card flat rounded="lg" class="mt-2">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-form ref="form" disabled>
                <v-text-field
                  v-model="meusDados.codigo"
                  label="Código"
                ></v-text-field>
                <v-text-field
                  v-model="meusDados.nome"
                  label="Representante/Vendedor"
                ></v-text-field>
                <v-text-field
                  v-model="meusDados.cpf_cnpj"
                  label="CPF/CNPJ"
                ></v-text-field>
                <v-text-field
                  :value="meusDados.cidade + ' - ' + meusDados.uf"
                  label="Cidade"
                ></v-text-field>
                <v-text-field
                  v-model="meusDados.endereco"
                  label="Endereço"
                ></v-text-field>
                <v-text-field
                  v-model="meusDados.cep"
                  label="Endereço"
                ></v-text-field>
                <v-text-field
                  v-model="meusDados.telefone"
                  label="Telefone"
                ></v-text-field>
                <v-text-field
                  v-model="meusDados.email"
                  label="E-mail"
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapState } from "vuex";
import AlterarSenha from "@/components/config-conta/AlterarSenha.vue";
import CarregandoPadrao from "@/components/tela/CarregandoPadrao.vue";

export default {
  components: {
    TelaComponent,
    AlterarSenha,
    CarregandoPadrao,
  },
  computed: mapState("usuario", ["meusDados"]),
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions("usuario", ["getMeusDados"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.loading = true;
    await this.getMeusDados();
    this.loading = false;
  },
};
</script>

<style>
</style>
